import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  background-color: #000;
  position: fixed; /* Mudado de 'absolute' para 'fixed' */
  bottom: 0;
  left: 0;
  z-index: 10; /* Garante que o copyright fique por cima de outros elementos */

  img {
    height: 32px;
    width: 32px;
    margin: 5px 0px;
  }

  a {
    color: #fff;
    cursor: pointer;
    text-decoration: none;
  }

  @media screen and (max-width: 767px) {
    font-size: 0.7rem;

    img {
      height: 20px;
      width: 20px;
    }
  }
`;
